import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { MsgService } from './msg.service';
import { ApiErrorResponse } from '../Interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private msgService = inject(MsgService);
  private zone = inject(NgZone);
  private translateService = inject(TranslateService);

  public handleError(error: HttpErrorResponse): Promise<any> {
    if (!environment.production) {
      console.error(error);
    }

    let message = this.extractErrorMessage(error);

    switch (error.status) {
      case 0:

      // case 422:
      //   return Promise.reject(error);

      case 401:
        return Promise.reject(error);

      default:
        this.snackBarOpen(message);
        return Promise.reject(error);
    }
  }

  private snackBarOpen(message: string): void {
    this.zone.run(() => {
      this.msgService.showSnackBar(message, { type: 'error', duration: 5000 });
    });
  }

  private extractErrorMessage(error: any): string {
    const apiError: ApiErrorResponse | undefined = error?.error;

    if (apiError?.code) {
      const translationKey = `shared.api.errors.${apiError.code}`;
      const translated = this.translateService.instant(translationKey);

      if (translated !== translationKey) {
        return translated;
      }
    }
    return (
      apiError?.message ||
      error?.error?.error ||
      error?.error?.message ||
      error?.message ||
      this.translateService.instant('shared.api.errors.default')
    );
  }
}
